import React from "react";

const KeyboardIcon: React.FC = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66536 22.1673C4.0237 22.1673 3.47459 21.939 3.01803 21.4825C2.56148 21.0259 2.33281 20.4764 2.33203 19.834V8.16732C2.33203 7.52565 2.5607 6.97654 3.01803 6.51998C3.47536 6.06343 4.02448 5.83476 4.66536 5.83398H23.332C23.9737 5.83398 24.5232 6.06265 24.9805 6.51998C25.4379 6.97732 25.6661 7.52643 25.6654 8.16732V19.834C25.6654 20.4757 25.4371 21.0252 24.9805 21.4825C24.524 21.9398 23.9745 22.1681 23.332 22.1673H4.66536ZM4.66536 19.834H23.332V8.16732H4.66536V19.834ZM9.33203 18.6673H18.6654V16.334H9.33203V18.6673ZM5.83203 15.1673H8.16536V12.834H5.83203V15.1673ZM9.33203 15.1673H11.6654V12.834H9.33203V15.1673ZM12.832 15.1673H15.1654V12.834H12.832V15.1673ZM16.332 15.1673H18.6654V12.834H16.332V15.1673ZM19.832 15.1673H22.1654V12.834H19.832V15.1673ZM5.83203 11.6673H8.16536V9.33398H5.83203V11.6673ZM9.33203 11.6673H11.6654V9.33398H9.33203V11.6673ZM12.832 11.6673H15.1654V9.33398H12.832V11.6673ZM16.332 11.6673H18.6654V9.33398H16.332V11.6673ZM19.832 11.6673H22.1654V9.33398H19.832V11.6673Z"
        fill="#515C66"
      />
    </svg>
  );
};

export default KeyboardIcon;
